import Head from 'next/head'
import { GTMtag } from 'lib/tags'
import { GOOGLE_FONTS_STYLESHEET } from 'lib/googleFonts'
import { useState, useEffect } from 'react'

interface Props {
  title: string
  description: string
  keyword: string
  image: string
  url: string
  noindexNofollow?: boolean
}

const CustomHead: React.FC<Props> = ({ title, description, keyword, image, url, noindexNofollow }) => {
  const [isIE, setIsIE] = useState(false)

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
      setIsIE(true)
    }
  }, [])

  return (
    <Head>
      <link rel="icon" href="/favicon.ico" />
      <link rel="stylesheet" href="https://use.typekit.net/bsu7ery.css" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="keywords" content={keyword} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="google-site-verification" content="M1NrPwIhg3qEUcvmXJoe3Ba8GzyRFeZObOLBQu9agLM" />
      <link rel="canonical" href={url} />
      <link rel="shortcut icon" href={'/favicon.ico'} />
      <link rel="apple-touch-icon" href={'/favicon.ico'} />
      <script
        dangerouslySetInnerHTML={{
          __html: `${GTMtag}`,
        }}
      ></script>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href={GOOGLE_FONTS_STYLESHEET} rel="stylesheet" />
      {noindexNofollow && <meta name="robots" content="noindex , nofollow" />}
      <script
        type="text/javascript"
        src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
      ></script>
      <script src="/js/headerfooter.js"></script>
    </Head>
  )
}

export default CustomHead
